var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/hooks/useDefaultTransComponents.tsx";
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { config, useTheme } from '@adc/parallax-component-library';
const Link = ({
  onPressLink,
  href,
  target,
  children
}) => {
  const textActive = useTheme()['interactive.core.enabled'].get();
  const fontSize = config.fonts.body.size['bodyBase.default'];
  if (onPressLink && href && !href?.startsWith('https')) {
    return /*#__PURE__*/React.createElement("a", {
      // this href is here only to satisfy eslint rule anchor-is-valid
      // how we use the preventDefault the 'a' tag doesn't trigger what is triggered is the onPressLink
      href: href,
      id: href,
      style: {
        color: `${textActive}`,
        fontSize: `${fontSize}px`,
        overflow: 'visible',
        width: 'auto',
        background: 'none',
        margin: 0,
        padding: 0,
        border: 'none',
        cursor: 'pointer',
        textDecoration: 'none'
      },
      onClick: e => {
        e.preventDefault();
        return onPressLink(href);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 7
      }
    }, children);
  }
  return /*#__PURE__*/React.createElement("a", {
    id: href,
    target: target,
    href: href ? href : '',
    style: {
      color: `${textActive}`,
      textDecoration: 'none'
    },
    rel: "noreferrer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }, children);
};
const useDefaultTransComponents = (onPressLink, customNodes) => {
  const fontFamily = config.fonts.body.family;
  const fontWeightStrong = config.fonts.body.weight['bodyBase.strong'];
  const fontSize = config.fonts.body.size['bodyBase.strong'];
  return {
    strong: /*#__PURE__*/React.createElement("strong", {
      style: {
        fontFamily,
        fontWeight: fontWeightStrong,
        fontSize
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 13
      }
    }),
    a: /*#__PURE__*/React.createElement(Link, {
      onPressLink: onPressLink,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 8
      }
    }),
    ...customNodes
  };
};
export default useDefaultTransComponents;